import Vue from 'vue'
import App from './App.vue'

// 👉 正确：Vue2 + Element UI
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

// vue3 + element plus
// import * as ElementPlusIconsVue from '@element-plus/icons-vue'
// for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
//   Vue.component(key, component)
// }

// 引入路由
import router from './router'

// 引入axios
import axios from 'axios'

// 引入这两个
import { createPinia, PiniaVuePlugin } from 'pinia'
import VueCompositionAPI from '@vue/composition-api'

// 全局挂载到Vue原型
Vue.prototype.$axios = axios


Vue.use(ElementUI)
Vue.config.productionTip = false

// 必须先use这个
Vue.use(VueCompositionAPI)
Vue.use(PiniaVuePlugin)

const pinia = createPinia()

new Vue({
  router,
  pinia,
  render: h => h(App),
}).$mount('#app')

// ======================
// 全局前置守卫 —— 写在这里
// ======================
router.beforeEach((to, from, next) => {
  console.log('将要跳转：', to.path)
  
  // 必须写 next() 放行！
  next()
  // if(to.name == "member"){
  //   next(false) // 跳转到 member 页面时，不进行跳转
  // }else {
  //   next()
  // }
})